import { Outlet } from 'react-router-dom';

import DashboardLayout from '@layouts/dashboardLayout/Dashboard.layout';
import EmployeeManagementUpdatePage from 'pages/employee-management/employee-management-update';
import EmployeeManagementViewPage from 'pages/employee-management/employee-management-view';
import { ROUTES } from 'constants/routes';
import WithAuth from 'shared/components/hocs/with-auth';

export const EMPLOYEE_MANAGEMENT_ROUTES = {
  path: '',
  element: <Outlet />,
  children: [
    {
      path: ROUTES.EMPLOYEE_MANAGEMENT.ROOT,
      element: (
        <WithAuth>
          <DashboardLayout>
            <EmployeeManagementViewPage />
          </DashboardLayout>
        </WithAuth>
      ),
    },
    {
      path: `${ROUTES.EMPLOYEE_MANAGEMENT.UPDATE_FILE.path}/:employeeId`,
      element: (
        <DashboardLayout>
          <EmployeeManagementUpdatePage />
        </DashboardLayout>
      ),
    },
  ],
};
